import { render, staticRenderFns } from "./StylistCertifications.vue?vue&type=template&id=aa313fc6"
import script from "./StylistCertifications.vue?vue&type=script&lang=js"
export * from "./StylistCertifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports